/**
 * 按时间键归一化：去重（保留最后一条）+ 升序排序。
 *
 * lightweight-charts 对 `time` 的唯一性、单调性做硬断言，越界即抛错并让整个视图崩溃。
 * 「同一分钟」出现多条 tick（如同一秒多次推送）时保留最后一条 —— 与「最后成交价为准」一致。
 *
 * `key` 是数值型时间键：分时用 **epoch 秒**（真实时间戳），其余场景可传序号。
 */
export function dedupeByTime(
  rows: { key: number; value: number | null }[],
): { key: number; value: number }[] {
  const byKey = new Map<number, number | null>();
  for (const r of rows) byKey.set(r.key, r.value);
  return [...byKey.entries()]
    .sort((a, b) => a[0] - b[0])
    // null 会让图表库画断线，分时均价线不应出现空洞
    .filter((e): e is [number, number] => e[1] !== null && Number.isFinite(e[1]))
    .map(([key, value]) => ({ key, value }));
}
